import { supabase } from "./supabase";

/**
 * Organização ativa de quem está logado (migration 269): a própria, ou a do
 * "Ver como" do super admin. Trocar de organização recarrega a página, então
 * uma consulta por carga basta.
 */
let ativa: Promise<string> | null = null;

export const organizacaoAtiva = (): Promise<string> => {
  if (!ativa) {
    ativa = Promise.resolve(supabase.rpc("organizacao_ativa" as never)).then(({ data, error }) => {
      if (error || !data) {
        ativa = null;
        throw error ?? new Error("Organização não encontrada.");
      }
      return String(data);
    });
  }
  return ativa;
};

/** Caminho no bucket attachments: cada organização na própria pasta (274). */
export const caminhoDoAnexo = async (nomeArquivo: string) => `${await organizacaoAtiva()}/${nomeArquivo}`;
